
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Toothache(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Toothache"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Pain or inflammation in or around the tooth, often caused by tooth decay or infection.</p>
                                <p>A toothache can be caused by anything from a popcorn hull stuck
                                    in your gum to a broken tooth or a bacterial infection. Some
                                    toothaches may come from temporary gum irritation.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Toothache/1.jpeg")} alt="Toothache" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Tooth pain that may be sharp, throbbing, or constant. In some people, pain results only when
                                    pressure is applied to the tooth (biting down on something).</p>

                                <p>
                                    Swelling around the tooth.</p>
                                <p>
                                    Fever or headache.</p>
                                <p>Foul-tasting drainage from the infected tooth.</p>
                                <p><a className='links' href='https://my.clevelandclinic.org/health/symptoms/17771-bad-breath-halitosis'>A bad odor from the mouth</a></p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Toothache">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Toothache;